import { exercises } from "./reducer";

export const fetchExercises = () => {
  return {
    type: contactActions.FETCH_EXERCISES
  };
};

export const fetchExerciseLogsNotMatching = () => {
  return {
    type: contactActions.FETCH_EXERCISE_LOGS_NOT_MATCHING
  };
};

export const fetchExercisesSuccess = exercises => ({
  type: contactActions.FETCH_EXERCISES_SUCCESS,
  payload: { exercises }
});

function ascendingSort(contact1, contact2) {
  const name1 = contact1.name ? contact1.name.toUpperCase() : "~";
  const name2 = contact2.name ? contact2.name.toUpperCase() : "~";
  return name1 > name2 ? 1 : name1 === name2 ? 0 : -1;
}

export const createExercise = exercise => {
  return dispatch => {
    dispatch({
      type: contactActions.CREATE_EXERCISE,
      payload: exercise
    });
  };
};

export const updateExercise = payload => {
  return (dispatch, getState) => {
    dispatch({
      type: contactActions.UPDATE_EXERCISE,
      payload
    });
  };
};

const contactActions = {
  CREATE_EXERCISE: "CREATE_EXERCISE",
  UPDATE_EXERCISE: "UPDATE_EXERCISE",
  DELETE_EXERCISE: "DELETE_EXERCISE",
  REMOVE_EXERCISE: "REMOVE_EXERCISE",
  ADD_EXERCISE: "ADD_EXERCISE",
  EDIT_CONTACT: "EDIT_CONTACT",
  DELETE__CONTACT: "DELETE__CONTACT",
  CHANGE_CONTACT: "CHANGE_CONTACT",
  EDIT_VIEW: "EDIT_VIEW",
  FETCH_EXERCISES: "FETCH_EXERCISES",
  FETCH_EXERCISES_SUCCESS: "FETCH_EXERCISES_SUCCESS",
  SAVE_EXERCISES: "SAVE_EXERCISES",
  SHOW_CREATE_MODAL: "SHOW_CREATE_MODAL",
  HIDE_CREATE_MODAL: "HIDE_CREATE_MODAL",
  ACTIVATE_EXERCISE: "ACTIVATE_EXERCISE",
  DEACTIVATE_EXERCISE: "DEACTIVATE_EXERCISE",
  FETCH_EXERCISE_LOGS_NOT_MATCHING: "FETCH_EXERCISE_LOGS_NOT_MATCHING",
  HIDE_EX_REPLACEMENT_LOG: "HIDE_EX_REPLACEMENT_LOG",
  REPLACE_EX_REPLACEMENT_LOG: "REPLACE_EX_REPLACEMENT_LOG",
  DELETE_EXERCISE: "DELETE_EXERCISE",
  PATCH_EXERCISE: "PATCH_EXERCISE",
  changeContact: (id, tracking_type) => ({
    type: contactActions.CHANGE_CONTACT,
    tracking_type: tracking_type,
    id
  }),

  editContact: newContact => {
    return (dispatch, getState) => {
      const contacts = getState().Contacts.get("contacts");
      const newContacts = [];
      contacts.forEach(contact => {
        if (contact.id === newContact.id) {
          newContacts.push(newContact);
        } else {
          newContacts.push(contact);
        }
      });
      dispatch({
        type: contactActions.EDIT_CONTACT,
        contacts: newContacts.sort(ascendingSort)
      });
    };
  },
  deleteContact: id => {
    return (dispatch, getState) => {
      const contacts = getState().Contacts.get("contacts");
      const seectedId = getState().Contacts.get("seectedId");
      const newContacts = [];
      contacts.forEach(contact => {
        if (contact.id === id) {
        } else {
          newContacts.push(contact);
        }
      });
      dispatch({
        type: contactActions.DELETE__CONTACT,
        contacts: newContacts,
        seectedId: id === seectedId ? undefined : seectedId
      });
    };
  },
  viewChange: view => ({
    type: contactActions.EDIT_VIEW,
    view
  }),
  saveExercise: (exercise, selected) => {
    return (dispatch, getState) => {
      dispatch({
        type: contactActions.SAVE_EXERCISES,
        exercise: {
          ...exercise,
          tracking_type: selected
        }
      });
    };
    return;
  },

  deleteExercise: exercise => {
    return (dispatch, getState) => {
      dispatch({
        type: contactActions.DELETE_EXERCISE,
        payload: {
          exercise
        }
      });
    };
  },
  removeExercise: exercise_id => {
    return (dispatch, getState) => {
      dispatch({
        type: contactActions.REMOVE_EXERCISE,
        payload: {
          exercise_id
        }
      });
    };
  },
  showCreateModal: () => {
    return (dispatch, getState) => {
      dispatch({
        type: contactActions.SHOW_CREATE_MODAL
      });
    };
  },
  hideCreateModal: () => ({
    type: contactActions.HIDE_CREATE_MODAL
  })
};
export default contactActions;

export const activateExercise = payload => ({
  type: contactActions.ACTIVATE_EXERCISE,
  payload
});

export const deactivateExercise = () => ({
  type: contactActions.DEACTIVATE_EXERCISE
});
export const hide_replacement_log = payload => ({
  type: contactActions.HIDE_EX_REPLACEMENT_LOG,
  payload
});
export const replace_ex_replacement_log = payload => ({
  type: contactActions.REPLACE_EX_REPLACEMENT_LOG,
  payload
});

export const deleteExercise = payload => ({
  type: contactActions.DELETE_EXERCISE,
  payload
});

export const patchExercise = payload => ({
  type: contactActions.PATCH_EXERCISE,
  payload
});
